module.exports = __webpack_public_path__ + "a51c19d0073bba6738818e122744041a.png";